import { Directive } from '@angular/core';
import { TemplateRefDirective } from 'src/app/utils/template-ref-directive';

@Directive({
    selector: '[appListingSearchbarContent]',
    standalone: false
})
export class ListingSearchbarContentDirective extends TemplateRefDirective {
}
